import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import LottieRemote from '@components/lottie/LottieRemote';
import { css } from '@emotion/react';
import { useAnalytics } from '@lusha-engage/analytics';
import { Button } from '@lusha-ui/button';
import { GridContainer } from '@lusha-ui/core';
import { Text } from '@lusha-ui/text';
import { colors } from '@lusha-ui/theme';
import React, { useState } from 'react';
import { useAsyncFetch } from 'react-hooks-async-handlers';
import EmotionsSvg from '../assets/emotions.svg';
import StarActive5Svg from '../assets/star-active-5.svg';
import starLottieAnimationUrl from '../assets/star-animation.static.json';
function RateTopView(props) {
    const { onRateUsOnStore } = props;
    const [isLottieEnabled, setLottieEnabled] = useState(true);
    const analytics = useAnalytics();
    useAsyncFetch(() => __awaiter(this, void 0, void 0, function* () {
        analytics.track({ eventType: 'plugin_rate_on_store_redirect_displayed', event_value: '5' });
    }));
    function handleRateUsOnStore() {
        const href = 'https://chromewebstore.google.com/detail/lusha-easily-find-b2b-con/mcebeofpilippmndlpcghpmghcljajna/reviews';
        window.open(href, '_blank');
        analytics.track({
            eventType: 'plugin_rate_on_store_redirect_clicked',
        });
        onRateUsOnStore();
    }
    return (_jsxs("div", { children: [_jsx(GridContainer, { justifyContent: 'center', css: css `
          margin-bottom: 8px;
        `, children: _jsxs("div", { css: css `
            position: relative;
            width: 52px;
            height: 52px;
            border-radius: 26px;
            justify-content: center;
            align-items: center;
            display: flex;
            background-color: ${colors.fill.brand['1'].DEFAULT};
          `, children: [_jsx("div", { css: css `
              position: absolute;
              top: -1px;
              right: -6px;
            `, children: _jsx(EmotionsSvg, {}) }), _jsx("div", { css: css `
              position: absolute;
              z-index: 30;
            `, children: _jsx(StarActive5Svg, {}) }), isLottieEnabled && (_jsx("div", { css: css `
                position: absolute;
                z-index: 0;
              `, children: _jsx(LottieRemote, { url: starLottieAnimationUrl, options: {
                                    loop: false,
                                    autoplay: true,
                                }, height: 70, width: 70, eventListeners: [
                                    {
                                        eventName: 'complete',
                                        callback: () => {
                                            setLottieEnabled(false);
                                        },
                                    },
                                ] }) }))] }) }), _jsx(Text, { variant: 'large20B', display: 'block', textAlign: 'center', css: css `
          margin-bottom: 4px;
        `, children: "We're glad you like it!" }), _jsxs(Text, { variant: 'small14R', display: 'block', textAlign: 'center', children: ["Your review helps others discover ", _jsx("br", {}), "our extension"] }), _jsx("div", { css: css `
          padding: 0 24px;
          margin-top: 24px;
        `, children: _jsx(Button, { size: 'small', onClick: handleRateUsOnStore, width: '100%', children: "Rate us on store" }) })] }));
}
export default RateTopView;
